<div class="back-button">
    <a href="javascript:void(0)" (click)="goBack()">
        <img src="../../../../assets/svg/fi-rs-arrow-left.svg" loading="lazy" alt="Back">
    </a>
</div>
<div class="main-wrapper">
    <div class="forget-container">
        <div class="forget-center">
            <h2>{{ 'auth.forgot-password.title' | translate }}</h2>
        </div>

        <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()" class="forget-form" id="forgot-password-form">
            <div class="form-group">
                <label for="email">{{ 'common.email' | translate }}</label>
                <input type="email" id="email" class="form-control" formControlName="email">
                <div class="error-message" *ngIf="shouldShowError('email')">
                    {{ getErrorMessage('email') }}
                </div>
            </div>
            <button type="submit" class="forget-btn" [disabled]="forgotPasswordForm.invalid" aria-label="Search password"
            [ngClass]="{'disabled': forgotPasswordForm.invalid }" form="forgot-password-form">{{ 'auth.forgot-password.reset-password' | translate }}</button>
        </form>
    </div>
</div>